export default {
  setVirtualAccounts(state, value) {
    state.myVirtualAccounts = value;
  },
  setBanks(state, value) {
    state.banks = value;
  },

  setWalletStats(state, value) {
    state.walletStats = value;
  },

  setUserWalletInformation(state, value) {
    state.userWalletInformation = value;
  },
  setAuditTrailLogs(state, value) {
    state.auditTrailLogs = value;
  },
  setAuditTrailTotal(state, value) {
    state.auditTrailTotal = value;
  },
  setAuditTrailCurrentPage(state, value) {
    state.auditTrailCurrentPage = value;
  },
  setAuditTrailPerPage(state, value) {
    state.auditTrailPerPage = value;
  },
  setAuditTrailSubModule(state, value) {
    state.auditTrailSubModule = value;
  },
  setAuditTrailCauserId(state, value) {
    state.auditTrailCauserId = value;
  },
  setAuditTrailStartDate(state, value) {
    state.auditTrailStartDate = value;
  },
  setAuditTrailEndDate(state, value) {
    state.auditTrailEndDate = value;
  },
  setAuditTrailTableLoading(state, value) {
    state.auditTrailTableLoading = value;
  },
};
